export default "__VITE_ASSET__CqR0a_Dj__"